import { deserealizeAEMCookieCollection } from 'utils/cookie.helper';
import { TBasketItem } from '../types/basket-item.type';

export const deserealizeBasket = deserealizeAEMCookieCollection<TBasketItem>((item: string) => {
  const [code, qty] = item.split(':');
  return {
    code,
    quantity: parseFloat(qty),
  };
});
